import { TypeHelper } from "@iconics/core";
import { ODataSelect } from "@iconics/core";

export class VirtualTreeView extends ODataSelect
{
    public Id = 0;
    public Name = '';
    public DisplayName = '';
    public Description = '';
    public Definition = '';
    public OntologyId = '';
    public IsEnabled = false;
    public '@odata.etag' = '';

    public init(response: any): ODataSelect
    {
        Object.assign(this, response);
        this.IsEnabled = TypeHelper.toBoolean(response.IsEnabled) ?? false;
        return this;
    }

    public toSelect(): string
    {
        return '';
    }
}

export interface IOntology
{
    Name: string;
    IsEnabled: string;
    Id: string;
}

export interface IImportResultWrapper
{
    Success: IImportResult;
    Failure: IImportResult;
}

export interface IImportResult
{
    TreeViews: string[];
}